import { evaluateExpression } from '../../../utils/formula/evaluateExpression.js'

/**
 * Generic formula operation for header fields.
 *
 * Evaluates a sandboxed math expression and writes the result to targetField.
 *
 * Config shape (in fieldsLogicData.js):
 * {
 *     logicType: 'calcFields',
 *     operationType: 'header.formula',
 *     formula: '$1 * (1 + $2)',   // $N maps to args[N-1]
 *     args: ['netSalesPrice', 'taxRate'],  // field names resolved from data
 *     targetField: 'grossSalesPrice',
 *     decimals: 5                  // optional, defaults to 5
 * }
 */
const headerFormula = (data, operation) => {
    const { formula, args = [], targetField, decimals = 5 } = operation

    if (!formula || !targetField) return data

    const resolvedArgs = args.map(a => {
        const v = data[a]
        return typeof v === 'number' ? v : 0
    })

    const result = evaluateExpression(formula, resolvedArgs, { decimals })
    if (result === null) return data

    return { ...data, [targetField]: result }
}

export default headerFormula
